import { FormLayout } from "@careinfo/layout";
import { useForm } from "react-hook-form";
import BrokerForm from "./BrokerForm";

const EditBroker = (props: any) => {
  const { handleEdit, isLoading, data } = props;
  const {
    handleSubmit,
    register,
    formState: { errors },
    setError,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        ...data,
      };
    },
  });

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <BrokerForm register={register} errors={errors} />
    </FormLayout>
  );
};

export default EditBroker;
